// Fill complete rows in both the two- and three-column card grids.
export const MARKETPLACE_PAGE_SIZE = 24;
export const POPULAR_PLUGIN_CATEGORY_KEY = 'popular';
export const POPULAR_SKILL_CATEGORY = 'Popular';
export const DISCOVER_CATEGORY_LIMIT = 6;
//# sourceMappingURL=marketplaceConstants.js.map